import React from 'react';
import HeroSection from '../components/landing/HeroSection';
import CalculatorSection from '../components/landing/CalculatorSection';
import ProcessSection from '../components/landing/ProcessSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import PricingSection from '../components/landing/PricingSection';
import ClosingSection from '../components/landing/ClosingSection';
import StickyFooter from '../components/landing/StickyFooter';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <HeroSection />
      <CalculatorSection />
      <ProcessSection />
      <TestimonialsSection />
      <PricingSection />
      <ClosingSection />
      <StickyFooter />
    </div>
  );
};

export default LandingPage;
